import { useState } from 'react';
import { Link } from 'react-router';

import { ROUTES } from '@/shared/config';
import { FinishedMatchList, MatchList } from '@/widgets/match-list';

import styles from './MatchesPage.module.scss';

type Tab = 'open' | 'finished';

export function MatchesPage() {
  const [tab, setTab] = useState<Tab>('open');

  return (
    <div className={styles.page}>
      <div className={styles.titleRow}>
        <Link className={styles.back} to={ROUTES.home} aria-label="Назад">
          <img src="/images/matches/back.svg" alt="" aria-hidden className={styles.backIcon} />
        </Link>
        <h1 className={styles.title}>Прогнозы</h1>
      </div>

      <div className={styles.tabs} role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'open'}
          className={tab === 'open' ? styles.tabActive : styles.tab}
          onClick={() => {
            setTab('open');
          }}
        >
          Прогнозы
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'finished'}
          className={tab === 'finished' ? styles.tabActive : styles.tab}
          onClick={() => {
            setTab('finished');
          }}
        >
          Завершённые
        </button>
      </div>

      {tab === 'open' ? <MatchList /> : <FinishedMatchList />}
    </div>
  );
}
